import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
  },
});

console.log('🔴 Redux Store: Store configured with counter reducer');

export default store;
